/** @jsxImportSource @emotion/react */
import Box from '@mui/material/Box';
import Text from '@Text';
import { useTheme } from '@emotion/react';
import makeNewsletterConsentStatementStyles from './makeNewsletterConsentStatementStyles';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';

const NewsletterConsentStatement = ({ statement }) => {
  const theme = useTheme();
  const classes = makeNewsletterConsentStatementStyles({ theme });

  const textExperimentName = useGetExperimentName({
    componentName: 'Text',
  });

  return (
    <Box css={classes.privacyPolicyContainer}>
      <Text variant="footer" experimentName={textExperimentName}>
        <span
          id="newsletterConsentStatement"
          dangerouslySetInnerHTML={{
            __html: statement,
          }}
        />
      </Text>
    </Box>
  );
};

export default NewsletterConsentStatement;
